import * as RasaInput from '../../components/rasa-input'
import * as Types from './types'

export const addUserKeyModalStateValid = (state: Types.UserKeyModalData): boolean =>
  !RasaInput.validateTitle(state.name).invalid



// WEBPACK FOOTER //
// ./src/pages/user-settings/utils.ts